import {useListView} from '../core/ListViewProvider'
import {PaymentMethodListToolbar} from './PaymentMethodListToolbar'
import {PaymentMethodListGrouping} from './PaymentMethodListGrouping'
import {PaymentMethodListSearchComponent} from './PaymentMethodListSearchComponent'

const PaymentMethodListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <PaymentMethodListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PaymentMethodListGrouping /> : <PaymentMethodListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {PaymentMethodListHeader}
